// extracted by mini-css-extract-plugin
export default {"login-button--only-icon":"l7RTD","login-button--with-user":"AfqZl","login-text":"WkXmK"};